import type { Box } from 'features/knowledgeDocumentViewer/components/viewer/shared/types'
import { useCallback, useState } from 'react'

export const useBoxHover = (onBoxHover?: (box: Box | null) => void) => {
  const [hoverId, setHoverId] = useState<string | null>(null)

  const handleMouseEnter = useCallback(
    (box: Box) => {
      setHoverId(box.id)
      onBoxHover?.(box)
    },
    [onBoxHover]
  )

  const handleMouseLeave = useCallback(() => {
    setHoverId(null)
    onBoxHover?.(null)
  }, [onBoxHover])

  return { hoverId, handleMouseEnter, handleMouseLeave }
}
